import type { ImportedProfile } from '@/types/passcode-list.types';
import { Post } from '../helpers';

export default function AddUsersToList({
  channel,
  projectUuid,
  passcodeLists,
  usersToAdd,
  signal,
}: {
  channel: number;
  projectUuid: string;
  passcodeLists: number[];
  usersToAdd: ImportedProfile[];
  signal?: AbortSignal;
}) {
  return Post<{ message: string }>({
    url: `/v4/admin/attendees/${channel}/${projectUuid}/add-users-to-list`,
    body: { passcodeLists, usersToAdd },
    signal,
  });
}
